/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Record_MovementInputs */



/**
* | output |
* | --- |
* | "Record movement" |
*
* @param {Promo_Record_MovementInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_record_movement = /** @type {((inputs?: Promo_Record_MovementInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Record_MovementInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer un mouvement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar movimiento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar movimentação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra movimento")
	return /** @type {LocalizedString} */ ("Record movement")
});